import styled from "styled-components";

export const VideosGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(1fr);
  gap: ${({ theme }) => theme.marginPx("mobile")};

  ${({ theme }) => theme.breakpoints.tablet} {
    grid-template-columns: repeat(2, 1fr);
    gap: ${({ theme }) => theme.spacePx("tablet", 8)};
  }

  ${(props) =>
    props.theme.apply(["desktop", "screen"], (breakpoint: string) => {
      return `
        grid-template-columns: repeat(3, 1fr);
        grid-gap: ${props.theme.spacePx(breakpoint, 8)};
      `;
    })}
`;
